import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { couponListColumns } from "../../constant/tables-columns/tablesColums";
import { useNavigate } from "react-router";
import { digitsThree } from "../../utils/price";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { convertDate } from "../../utils/convertDate";

export default function CouponList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [couponData, setCouponData] = useState([]);
  const { utils } = useSelector(utilsState);

  const getCoupon = async () => {
    const path = "admin/coupons";
    return tableRequest.load({ path }, (response) => {
      setCouponData(response?.data?.result.data);
    });
  };

  useEffect(() => {
    getCoupon();
  }, []);

  const navigate = useNavigate();

  const data = [];

  couponData?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      expireDate: item?.expireDate ? convertDate(item?.expireDate) : "",
      isLimited: item?.isLimited ? "بله" : "خیر",
      value: `${digitsThree(item?.value)}` || "",
      type: item?.type == "price" ? "قیمت" : "درصد",
      minPrice: `${digitsThree(item?.minPrice)}` || "",
      maxPrice: `${digitsThree(item?.maxPrice)}` || "",
      id: item?._id,
      query: item?.forQueryParams.map((items) => {
        return <span>{items} ,</span>;
      }),
    })
  );

  const editCoupon = (singleCoupon) => {
    const newSingleCoupon = couponData.filter((item) => {
      return item._id == singleCoupon.id;
    });
    console.log(newSingleCoupon);
    navigate("/edit-coupon", { state: newSingleCoupon[0] });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست کوپن ها"} />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={couponListColumns} rows={data} onEdit={editCoupon} />
    </div>
  );
}
